import { Typography, Link, Breadcrumbs } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import './DiscoverHeader.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  title?: string;
  paragraph?: string;
  image: string;
  breadcrumb: string;
  dropdown?: boolean;
  mobile?: boolean;
  headerHtmlString?: string;
  hideBreadCrumbs?: boolean;
}

const DiscoverHeader = ({
  title,
  paragraph,
  image,
  breadcrumb,
  dropdown = true,
  headerHtmlString,
  hideBreadCrumbs = false
}: Props) => {
  return (
    <div className="discover-header">
      <div className="discover-header-left">
        {!hideBreadCrumbs && <CustomBreadcrumbs breadcrumb={breadcrumb} />}
        {headerHtmlString ? (
          <div
            className="discover-header-drup"
            dangerouslySetInnerHTML={{ __html: headerHtmlString }}
          />
        ) : (
          <>
            <h1 className="discover-header-title">{title}</h1>
            <p className="discover-header-paragraph">{paragraph}</p>
          </>
        )}
        {dropdown && <div className="discover-header-dropdown"></div>}
      </div>
      {/* <div className="discover-header-right"></div> */}
    </div>
  );
};

export const CustomBreadcrumbs = ({ breadcrumb }: { breadcrumb: string }) => {
  const { t } = useTranslation();
  const json = t("ndc-program.connection-options", { returnObjects: true});

  const hrefMap = json["hrefMap"];
  const textMap = json["textMap"];
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" sx={{ color: '#C9CACC'}} />}
      aria-label="breadcrumb"
      className="breadcrumbs"
    >
      <Link
        underline="hover"
        key="1"
        href={hrefMap}
        className="breadcrumbs-link"
        sx={{
          fontSize: '12px',
          lineHeight: '16px',
          fontWeight: 400,
          color: '#1D2939'
        }}
      >
        {textMap}
      </Link>
      <Typography key="2" className="breadcrumbs-title"
        sx={{
          fontSize: '12px',
          lineHeight: '16px',
          fontWeight: 700,
          color: '#1D2939',
        }}
      >
        {breadcrumb}
      </Typography>
    </Breadcrumbs>
  );
};

export default DiscoverHeader;
